<template>
  <el-table-column :label="label" :prop="prop" class-name="file-name" :sortable="sortable" >
    <template slot-scope="scope">
      <el-link type="primary"  @click.prevent="fileDownload(scope.row)" >{{ scope.row.excel_file_name }}</el-link>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'ファイル名'
    },
    prop: {
      type: String,
      default: 'file_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fileDownload (row) {
      row.syori = 'excel'
      this.$emit('filedownload', row)
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.file-name {
      width: 25em;
    }
  }
}
</style>
